import type { BadgeColor } from '@awork/_shared/types/color'
import type { AccessLevels } from '@awork/features/workspace/models/permissions.model'
import { DocumentContributor } from './document-contributor.model'
import { DocumentTeamAccess } from './document-team-access.model'

interface IDocumentSpace {
  id: string
  name: string
  emoji: string
  color: BadgeColor | null
  order: number
  contributors: DocumentContributor[]
  teams: DocumentTeamAccess[]
  workspaceAccessLevel?: AccessLevels
}

/**
 * The document space model
 */
export class DocumentSpace implements IDocumentSpace {
  id: string
  name: string
  emoji: string
  color: BadgeColor | null
  order: number
  contributors: DocumentContributor[]
  teams: DocumentTeamAccess[]
  workspaceAccessLevel?: AccessLevels

  constructor(documentSpace: Partial<IDocumentSpace>) {
    if (documentSpace.contributors) {
      documentSpace.contributors = documentSpace.contributors.map(c => new DocumentContributor(c))
    }

    if (documentSpace.teams) {
      documentSpace.teams = documentSpace.teams.map(c => new DocumentTeamAccess(c))
    }

    Object.assign(this, documentSpace)
  }
}
